(function () {
  const config = window.backEngravingConfig;
  if (!config?.enabled) return;

  const modal = document.getElementById('back-engraving-modal');
  if (!modal) return;

  const choiceStep = modal.querySelector('[data-step="choice"]');
  const textStep = modal.querySelector('[data-step="text"]');
  const textarea = modal.querySelector('[data-back-engraving-input]');
  const errorEl = modal.querySelector('[data-back-engraving-error]');
  const charCurrent = modal.querySelector('[data-char-current]');
  const charMax = modal.querySelector('[data-char-max]');

  let pendingForm = null;
  let pendingButton = null;

  function applyConfigText() {
    modal.querySelectorAll('[data-config]').forEach((el) => {
      const key = el.getAttribute('data-config');
      if (config[key]) el.textContent = config[key];
    });

    const yesBtn = modal.querySelector('[data-back-engraving-yes]');
    const noBtn = modal.querySelector('[data-back-engraving-no]');
    const confirmBtn = modal.querySelector('[data-back-engraving-confirm]');

    if (yesBtn) yesBtn.textContent = config.yesLabel;
    if (noBtn) noBtn.textContent = config.noLabel;
    if (confirmBtn) confirmBtn.textContent = config.confirmLabel;
    if (textarea) {
      textarea.placeholder = config.textPlaceholder;
      textarea.maxLength = config.charLimit;
    }
    if (charMax) charMax.textContent = config.charLimit;
  }

  function openModal(form, button) {
    pendingForm = form;
    pendingButton = button;
    resetModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    modal.querySelector('[data-back-engraving-yes]')?.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    pendingForm = null;
    pendingButton = null;
    resetModal();
  }

  function resetModal() {
    choiceStep.hidden = false;
    textStep.hidden = true;
    if (textarea) {
      textarea.value = '';
      textarea.classList.remove('is-error');
    }
    if (errorEl) errorEl.hidden = true;
    if (charCurrent) charCurrent.textContent = '0';
  }

  function showTextStep() {
    choiceStep.hidden = true;
    textStep.hidden = false;
    textarea?.focus();
  }

  function showChoiceStep() {
    textStep.hidden = true;
    choiceStep.hidden = false;
    if (textarea) textarea.classList.remove('is-error');
    if (errorEl) errorEl.hidden = true;
  }

  function validateProductForm(form) {
    const inputs = form.querySelectorAll('input, select, textarea');
    const skipValidation = Array.from(inputs).some((input) => input.value.trim() === 'No Engraving');

    if (skipValidation) return true;

    const isMultiEngraving = form.dataset.multiEngraving === 'true' || form.dataset.multiEngraving === '1';

    if (isMultiEngraving) {
      let isValid = true;
      let hasVisibleSets = false;

      for (let i = 1; i <= 5; i++) {
        const setContainer = form.querySelector(`.engraving-set[data-index="${i}"]`);
        if (!setContainer || window.getComputedStyle(setContainer).display === 'none') continue;

        hasVisibleSets = true;

        const textareaContainer = setContainer.querySelector('.engraving-textarea');
        const fileContainer = setContainer.querySelector('.engraving-file');
        const textInput = setContainer.querySelector('textarea');
        const fileInput = setContainer.querySelector('input[type="file"]');
        const positionInput = form.querySelector(`[name="properties[Position ${i}]"]`);

        if (textareaContainer && window.getComputedStyle(textareaContainer).display !== 'none') {
          if (!textInput || !textInput.value.trim()) {
            isValid = false;
            textareaContainer.classList.add('error');
          } else {
            textareaContainer.classList.remove('error');
          }
        }

        if (fileContainer && window.getComputedStyle(fileContainer).display !== 'none') {
          if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
            isValid = false;
            fileContainer.classList.add('error');
          } else {
            fileContainer.classList.remove('error');
          }
        }

        if (!positionInput || !positionInput.value.trim()) {
          isValid = false;
        }
      }

      return !hasVisibleSets || isValid;
    }

    let isValid = true;
    inputs.forEach((input) => {
      if (!input.hasAttribute('required')) return;
      if (window.getComputedStyle(input).display === 'none') return;

      const container = input.closest('div');
      if (input.type === 'file') {
        if (!input.value) {
          isValid = false;
          container?.classList.add('error');
        } else {
          container?.classList.remove('error');
        }
        return;
      }

      if (!input.value.trim()) {
        isValid = false;
        container?.classList.add('error');
      } else {
        container?.classList.remove('error');
      }
    });

    return isValid;
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('loading', loading);
  }

  function extractFormProperties(form) {
    const formData = new FormData(form);
    const properties = {};

    for (const [key, value] of formData.entries()) {
      if (!key.startsWith('properties[') || String(value).trim() === '') continue;
      const propName = key.slice(11, -1);
      properties[propName] = value;
    }

    return properties;
  }

  function formHasFileUploads(form) {
    return Array.from(form.querySelectorAll('input[type="file"]')).some(
      (input) => input.files && input.files.length > 0
    );
  }

  function generateLinkId() {
    return 'be_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function isServiceItem(item) {
    return (
      item.properties?._back_engraving === 'true' ||
      parseInt(item.variant_id, 10) === parseInt(config.variantId, 10)
    );
  }

  function isEngravedMainItem(item) {
    return Boolean(item.properties?.['Back Engraving Text']) && !isServiceItem(item);
  }

  function buildMainItem(form, backEngravingText, linkId) {
    const properties = extractFormProperties(form);

    if (backEngravingText) {
      properties['Back Engraving Text'] = backEngravingText;
      if (linkId) {
        properties._engraving_link_id = linkId;
      }
    }

    const item = {
      id: parseInt(form.querySelector('input[name="id"]')?.value, 10),
      quantity: parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1
    };

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return item;
  }

  function buildServiceItem(engravingText, productTitle, linkId) {
    const properties = {
      _back_engraving: 'true',
      'Engraving Text': engravingText,
      'For Product': productTitle || ''
    };

    if (linkId) {
      properties._engraving_link_id = linkId;
    }

    return {
      id: parseInt(config.variantId, 10),
      quantity: 1,
      properties
    };
  }

  function getCartAddUrl() {
    return (window.theme?.routes?.cart_add_url || '/cart/add') + '.js';
  }

  async function addItemsToCart(items) {
    if (typeof window.upcart !== 'undefined' && window.upcart.add) {
      const response = await window.upcart.add(items);
      if (response?.status) {
        throw new Error(response.description || 'Add to cart failed');
      }
      return { data: response, usedUpcart: true };
    }

    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const data = await response.json();
    if (data.status) {
      throw new Error(data.description || 'Add to cart failed');
    }

    return { data, usedUpcart: false };
  }

  async function addMainProductWithFiles(form, backEngravingText, linkId) {
    const formData = new FormData(form);

    if (backEngravingText) {
      formData.set('properties[Back Engraving Text]', backEngravingText);
      if (linkId) {
        formData.set('properties[_engraving_link_id]', linkId);
      }
    }

    const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript'
      },
      body: formData
    });

    const data = await response.json();
    if (data.status) {
      throw new Error(data.description || 'Add to cart failed');
    }

    return data;
  }

  async function addFreebiesIfNeeded(form) {
    const freebieList = form?.dataset?.freebies;
    if (!freebieList) return;

    const freebies = freebieList
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean)
      .map((id) => ({
        id: parseInt(id, 10),
        quantity: 1,
        properties: { _is_freebie: true }
      }));

    if (!freebies.length) return;

    await addItemsToCart(freebies);
  }

  function refreshCartOnce() {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }
  }

  function getServiceUpdatesForMainItem(items, mainItem) {
    const updates = {};
    const linkId = mainItem.properties?._engraving_link_id;
    const productTitle = mainItem.product_title;

    items.forEach((item) => {
      if (!isServiceItem(item)) return;

      if (linkId && item.properties?._engraving_link_id === linkId) {
        updates[item.key] = 0;
      } else if (!linkId && item.properties?.['For Product'] === productTitle) {
        updates[item.key] = 0;
      }
    });

    return updates;
  }

  async function applyCartUpdates(updates) {
    if (!updates || !Object.keys(updates).length) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    return true;
  }

  async function removeLinkedServicesImmediately(lineKey, lineIndex) {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const items = cart.items || [];

    let mainItem = null;

    if (lineKey) {
      mainItem = items.find((item) => item.key === lineKey);
    } else if (lineIndex > 0) {
      mainItem = items[lineIndex - 1];
    }

    if (!mainItem || !isEngravedMainItem(mainItem)) return false;

    return applyCartUpdates(getServiceUpdatesForMainItem(items, mainItem));
  }

  async function cleanupOrphanedBackEngraving() {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const items = cart.items || [];

    const activeLinkIds = new Set();
    const activeTitles = new Set();

    items.forEach((item) => {
      if (!isEngravedMainItem(item)) return;

      if (item.properties?._engraving_link_id) {
        activeLinkIds.add(item.properties._engraving_link_id);
      }

      activeTitles.add(item.product_title);
    });

    const updates = {};

    items.forEach((item) => {
      if (!isServiceItem(item)) return;

      const linkId = item.properties?._engraving_link_id;
      const forProduct = item.properties?.['For Product'];
      let shouldRemove = false;

      if (linkId) {
        shouldRemove = !activeLinkIds.has(linkId);
      } else if (forProduct) {
        shouldRemove = !activeTitles.has(forProduct);
      }

      if (shouldRemove) {
        updates[item.key] = 0;
      }
    });

    return applyCartUpdates(updates);
  }

  function installCartCleanup() {
    if (window.__backEngravingCleanupInstalled) return;
    window.__backEngravingCleanupInstalled = true;

    let cleaning = false;

    async function runCleanup() {
      if (cleaning) return;
      cleaning = true;

      try {
        const removed = await cleanupOrphanedBackEngraving();
        if (removed) {
          refreshCartOnce();
        }
      } catch (error) {
        console.error('Back engraving cleanup error:', error);
      } finally {
        cleaning = false;
      }
    }

    function scheduleCleanup(delay) {
      setTimeout(runCleanup, typeof delay === 'number' ? delay : 150);
    }

    document.addEventListener('theme:cart:update', scheduleCleanup);
    document.addEventListener('theme:cart:loaded', scheduleCleanup);

    document.addEventListener(
      'click',
      (event) => {
        const removeEl = event.target.closest(
          '[data-item-remove], a[href*="/cart/change"], a[href*="quantity=0"]'
        );

        if (!removeEl) return;

        const lineKey = removeEl.dataset?.id || '';
        const href = removeEl.getAttribute('href') || '';
        const lineMatch = href.match(/[?&]line=(\d+)/);
        const lineIndex = lineMatch ? parseInt(lineMatch[1], 10) : 0;

        removeLinkedServicesImmediately(lineKey, lineIndex)
          .then((removed) => {
            if (removed) {
              refreshCartOnce();
            }
          })
          .catch((error) => {
            console.error('Back engraving immediate cleanup error:', error);
          });

        scheduleCleanup(200);
      },
      true
    );

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const url = String(args[0]?.url || args[0] || '');

      if (['/cart/change', '/cart/update', '/cart/clear'].some((path) => url.includes(path))) {
        scheduleCleanup(100);
      }

      return response;
    };
  }

  async function proceedToCart(backEngravingText) {
    const form = pendingForm;
    const button = pendingButton;
    if (!form) return;

    setButtonLoading(button, true);

    try {
      const linkId = backEngravingText ? generateLinkId() : null;
      const serviceItem = backEngravingText
        ? buildServiceItem(backEngravingText, form.dataset.productTitle || '', linkId)
        : null;
      let usedUpcart = false;

      if (!formHasFileUploads(form)) {
        const items = [buildMainItem(form, backEngravingText, linkId)];
        if (serviceItem) items.push(serviceItem);
        const result = await addItemsToCart(items);
        usedUpcart = result.usedUpcart;
      } else {
        await addMainProductWithFiles(form, backEngravingText, linkId);
        if (serviceItem) {
          const result = await addItemsToCart([serviceItem]);
          usedUpcart = result.usedUpcart;
        }
      }

      await addFreebiesIfNeeded(form);

      if (!usedUpcart) {
        refreshCartOnce();
      }

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          bubbles: true
        })
      );

      closeModal();
    } catch (error) {
      console.error('Back engraving cart error:', error);
    } finally {
      setButtonLoading(button, false);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('[data-add-to-cart]');
      if (!button) return;

      const form = button.closest('form[data-product-form]');
      if (!form || form.dataset.backEngravingPopup !== 'true') return;

      if (button.hasAttribute('disabled') || button.disabled) return;

      const formWrapper = button.closest('[data-form-wrapper]');
      if (formWrapper?.classList.contains('variant--soldout')) return;

      if (!validateProductForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(form, button);
    },
    true
  );

  modal.querySelector('[data-back-engraving-yes]')?.addEventListener('click', showTextStep);

  modal.querySelector('[data-back-engraving-no]')?.addEventListener('click', () => {
    proceedToCart(null);
  });

  modal.querySelector('[data-back-engraving-back]')?.addEventListener('click', showChoiceStep);

  modal.querySelector('[data-back-engraving-confirm]')?.addEventListener('click', () => {
    const text = textarea?.value.trim() || '';

    if (!text) {
      textarea?.classList.add('is-error');
      if (errorEl) {
        errorEl.textContent = config.textError;
        errorEl.hidden = false;
      }
      return;
    }

    proceedToCart(text);
  });

  modal.querySelectorAll('[data-back-engraving-close]').forEach((el) => {
    el.addEventListener('click', closeModal);
  });

  textarea?.addEventListener('input', () => {
    const length = textarea.value.length;
    if (charCurrent) charCurrent.textContent = String(length);
    textarea.classList.remove('is-error');
    if (errorEl) errorEl.hidden = true;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  applyConfigText();
  installCartCleanup();
})();
